import React, { useEffect, useState } from "react";
import "./Search.css";
import { Globals as OldGlobals } from "../../global/Globals";
import { useLanguage } from "../../context/Languagecontext";


const Search = (props) => {
const { Globals, languages, setLanguages } = useLanguage();
const [searchTerm, setSearchTerm] = useState("");
const multiLang = localStorage.getItem("lang");

  useEffect(() =>{
    setSearchTerm(props.searchedFor || "");
  },[props.searchedFor]);

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    if(value ===""){
      props.onSearch(value);
    }
  };


  const handleSearch =(e) =>{
    props.onSearch(searchTerm);
  }

  const handleKeyPress =(e) =>{
    if(e.key === "Enter"){
      handleSearch();
    }
  }

  return (
    <>
      <div className={`searchBox ${searchTerm && searchTerm.length >0 ? "SelectedFilters" : ""}`} >
        <input
          className={`searchInput searchinput-${multiLang} ${props.placeholder === Globals.INTERNAL.BRIEFNO &&'search-brief'}` }
          type="text"
          placeholder={props.placeholder ? props.placeholder : Globals.PRODUCER.SEARCH }
          value={searchTerm}
          onChange={handleSearchChange}
          onKeyDown={handleKeyPress}
          onFocus={(e) => (e.target.style.cursor = "text")}
          onBlur={(e) => (e.target.style.cursor = "default")}
          title={props.placeholder ? props.placeholder : Globals.PRODUCER.SEARCH}
        />
        <div className="searchIcon" onClick={handleSearch}>
          <img src={OldGlobals.IMG.SEARCH} />
        </div>
      </div>
    </>
  );
};

export default Search;
